import { createResource } from 'react-resource-router';

import {
  RunnersStepQueueStatsResponse,
  RunnersStepQueueStats,
} from 'src/components/pipelines/models';
import envBaseUrl from 'src/components/pipelines/utils/env-base-url';

import { fetchData } from './utils';

const getUrl = (workspaceSlug: string) => {
  return `${envBaseUrl(
    '/!api/internal'
  )}/workspaces/${workspaceSlug}/pipelines-config/step-queue/stats`;
};

export const loadRunnersStepQueueStatsResource = createResource({
  type: 'runners-step-queue-stats',
  getKey: ({ match }) =>
    match?.params?.workspaceSlug ||
    match?.params?.repositoryOwner ||
    'runners-step-queue-stats',
  maxAge: 60000,
  getData: async ({ match }) => {
    const { workspaceSlug: workspaceSlugParam, repositoryOwner } = match.params;
    const workspaceSlug = repositoryOwner || workspaceSlugParam;

    if (!workspaceSlug) return null;

    const data: RunnersStepQueueStatsResponse = await fetchData(
      getUrl(workspaceSlug),
      'runners_step_queue_stats_resource_exception'
    );

    return new RunnersStepQueueStats(data);
  },
});
